import React, { useEffect, useState } from 'react';
import { Box, Button, MenuItem, Select, TextField, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { SecurityQuesListSelector, securityverifySelector, startSecurityQuestion } from '../../../../Store/UsersAccount/userAccount.slice.selector';

const SecurityQuestions = ({ onBack, onSubmit, loggedInUserData, emailValue }) => {
    const [answers, setAnswers] = useState([
        { questionId: '', answer: '', emailAuth: false, phoneAuth: false },
        { questionId: '', answer: '', emailAuth: false, phoneAuth: false },
        { questionId: '', answer: '', emailAuth: false, phoneAuth: false },
    ]);
    const [errors, setErrors] = useState([]);
    const [securityQuesListData, setSecurityQuesListData] = useState([]);
    const dispatch = useDispatch();
    const SecurityQuesList = useSelector(SecurityQuesListSelector);

    useEffect(() => {
        dispatch(startSecurityQuestion());
    }, [dispatch]);

    useEffect(() => {
        setSecurityQuesListData(SecurityQuesList.data || []);
    }, [SecurityQuesList]);

    const handleChange = (index, field, value) => {
        const updatedAnswers = [...answers];
        updatedAnswers[index][field] = value;
        setAnswers(updatedAnswers);

        // Clear error for the field being edited
        const updatedErrors = [...errors];
        updatedErrors[index] = { ...updatedErrors[index], [field]: '' };
        setErrors(updatedErrors);
    };

    const validateFields = () => {
        const newErrors = answers.map((answer, idx) => {
            const error = {};
            if (!answer.questionId) error.questionId = 'Please select a question.';
            if (!answer.answer.trim()) error.answer = 'Please provide an answer.';
            return error;
        });

        const hasDuplicates = new Set(answers.map((a) => a.questionId)).size !== answers.length;
        if (hasDuplicates) {
            answers.forEach((_, idx) => {
                newErrors[idx].questionId = 'Duplicate questions are not allowed.';
            });
        }

        setErrors(newErrors);
        return newErrors.every((error) => Object.keys(error).length === 0);
    };

    const handleSubmit = () => {
        if (!validateFields()) return;

        const dispatchedData = answers.map((q, idx) => ({
            email: emailValue,
            // question: securityQuesListData.find((item) => item.key === parseInt(q.questionId))?.value || '',
            answer: q.answer.trim(),
            questionId: q.questionId
        }));

        onSubmit(dispatchedData);
    };

    return (
        <Box sx={{ textAlign: 'center', padding: 3, minWidth: "60vh" }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
                <Button
                    variant="outlined"
                    color="secondary"
                    sx={{
                        border: 'none',
                        '&:hover': {
                            border: 'none',
                        }
                    }}
                    onClick={onBack}
                >
                    <ArrowBackIcon /> Back
                </Button>
            </Box>
            <Typography variant="h5" gutterBottom>
                Security Questions
            </Typography>
            {answers.map((answer, index) => (
                <Box key={index} sx={{ marginBottom: 3 }}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Box sx={{ flex: 1, marginRight: 1 }}>
                            <Select
                                value={answer.questionId}
                                onChange={(e) => handleChange(index, 'questionId', e.target.value)}
                                displayEmpty
                                fullWidth
                                error={!!errors[index]?.questionId}
                            >
                                <MenuItem value="" disabled>
                                    Select a Question
                                </MenuItem>
                                {securityQuesListData.map((q) => (
                                    <MenuItem key={q.key} value={q.key}>
                                        {q.value}
                                    </MenuItem>
                                ))}
                            </Select>
                            {errors[index]?.questionId && (
                                <Typography variant="caption" color="error">
                                    {errors[index].questionId}
                                </Typography>
                            )}
                        </Box>
                        <Box sx={{ flex: 1, marginLeft: 1 }}>
                            <TextField
                                value={answer.answer}
                                onChange={(e) => handleChange(index, 'answer', e.target.value)}
                                placeholder="Your Answer"
                                fullWidth
                                error={!!errors[index]?.answer}
                                helperText={errors[index]?.answer}
                            />
                        </Box>
                    </Box>
                </Box>
            ))}
            <Button variant="contained" color="error" onClick={handleSubmit} sx={{ marginTop: 2 }}>
                Submit
            </Button>
            {/* <Button variant="contained" color="error" onClick={onBack} sx={{ marginTop: 2, marginLeft: 2 }}>
                Go Back
            </Button> */}
        </Box>
    );
};

export default SecurityQuestions;
